module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "100000",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "arrow_box no-print animated infinite onboarding_animate"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e6d4768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/arrow.vue
// module id = 1910
// module chunks = 1